import React from "react";
import {
	AreaChart as AreaChartFromRecharts,
	Area,
	CartesianGrid,
	Tooltip,
	XAxis,
	YAxis,
	Legend,
	ResponsiveContainer
} from "recharts";
import { AreaChartLegendPayload, AreaChartProps } from "../../../../@types/charts/areaCharts.types";

const AreaChart: React.FC<AreaChartProps> = ({ areaData }) => {
	// console.log("Area Chart Data", areaData);
	const legendPayload: AreaChartLegendPayload[] = [
		{ value: "Previuos Year Enrollments (May, 2022 - April, 2023)", color: "#8884d8" },
		{ value: "Current Year Enrollments (May, 2023 - April, 2024)", color: "#82ca9d" }
	];
	return (
		// <ResponsiveContainer width={window.innerWidth < 1800 ? 475 : 775} height={320}>
		<ResponsiveContainer width="100%" height={360}>
			<AreaChartFromRecharts data={areaData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
				<defs>
					<linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
						<stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
						<stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
					</linearGradient>
					<linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
						<stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
						<stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
					</linearGradient>
				</defs>
				<XAxis dataKey="month" />
				<YAxis />
				<CartesianGrid strokeDasharray="3 3" />
				<Tooltip />
				<Legend payload={legendPayload} align="center" iconType="square" />
				<Area type="monotone" dataKey="previous" stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" />
				<Area type="monotone" dataKey="current" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" />
			</AreaChartFromRecharts>
		</ResponsiveContainer>
	);
};

export default AreaChart;
